import { apiRequest } from './api-client';

export interface SettingsData {
  minimumOrderValue: number;
}

export interface PricingSettings {
  cutCostPerUnit: number;
  setupCostPerOrder: number;
  marginRate: number;
  marginTiers: string | null;
  taxRate: number;
  vendorCommission: number;
  managerCommission: number;
}

export async function fetchMinimumOrder(accessToken: string): Promise<number> {
  // The endpoint returns { value: number } wrapped in the ResponseWrapperFilter envelope.
  // apiRequest unwraps the envelope, so data is { value: number }.
  const data = await apiRequest<{ value: number } | null>('/backoffice/settings/minimum-order', accessToken);
  return data?.value || 100;
}

export async function updateMinimumOrder(value: number, accessToken: string): Promise<void> {
  await apiRequest('/backoffice/settings/minimum-order', accessToken, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}

export async function fetchPricingSettings(accessToken: string): Promise<PricingSettings> {
  return apiRequest<PricingSettings>('/backoffice/settings/pricing', accessToken);
}

export async function updatePricingSettings(settings: Partial<PricingSettings>, accessToken: string): Promise<void> {
  await apiRequest('/backoffice/settings/pricing', accessToken, {
    method: 'PUT',
    body: JSON.stringify(settings),
  });
}
